module.exports = __webpack_public_path__ + "img/apollologo_v3.51c9bb7b.png";